<template>
    <div class="section-title">
        <!--<span class="number">{{num}}</span>-->
        <!--<h2>{{ text }}</h2>-->
        <h2>
            <img :src="titleSrc" alt="" class="text">
        </h2>
    </div>
</template>

<script>
import message from '@/assets/h2title/top/top01.svg'
import contents from '@/assets/h2title/top/top02.svg'
import partner from '@/assets/h2title/top/top03.svg'
import contact from '@/assets/h2title/top/top04.svg'

export default {
    props:{
        text: String,
        num: String,
    },
    data(){
        return{
            titleSrc: ''
        }
    },
    methods:{

    },
    mounted(){
        if( this.text == 'message'){
            this.titleSrc = message
        }
        if( this.text == 'contents'){
            this.titleSrc = contents
        }
        if( this.text == 'partner'){
            this.titleSrc = partner
        }
        if( this.text == 'contact'){
            this.titleSrc = contact
        }
    }
}
</script>

<style lang="scss" scoped>
    .section-title{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: row nowrap;
        width: 100%;
        img.text{
            height: 70px;
            width: auto;
            margin: 0 auto;
            @media #{$maxM}{
                height: 1em;
                max-width: 100%;
            }
        }
        h2{
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0.006em;
            @media #{$maxM}{
                font-size: 3.571em;
            }
        }
        .number{
            font-family: $rosewood;
            font-size: 2em;
            margin-top: 0.2em;
            margin-right: 18px;
            letter-spacing: normal;
            line-height: 1em;
            @media #{$maxM}{
                font-size: 1.214em;
                margin-right: 4px;
            }
            &:after{
                content: '';
                width: 100%;
                height: 2px;
                background: $black;
                display: block;
            }
        }
    }
</style>